// Automatically generated from TW.Saga.Core.Base, Version=1.0.0.0, Culture=neutral, PublicKeyToken=null @30.07.2019 13:39:28
import { ProcedureActionContext_abstract } from './../abstract/SagaActionLib/ProcedureActionContext_abstract';
export class ProcedureActionContext extends ProcedureActionContext_abstract {}
